import Utils from "../utils/Utils";

export default {

    init() {

        const SELECT_2 = ".select2";

        $(SELECT_2).each(function (index, select) {
            $(select).select2({
                width: '100%',
            });
        });

        const DATA_SUBMIT = "submit";
        const DATA_CONFIRM_MESSAGE = "confirm-message";

        const BTN_DESTROY = ".btn-destroy";

        $(BTN_DESTROY).click(function (e) {
            e.preventDefault();

            const confirm_message = $(this).data(DATA_CONFIRM_MESSAGE);

            const submit = $(this).data(DATA_SUBMIT);

            if (!Utils.isEmpty(submit)) {

                if (confirm(confirm_message)) {
                    $(submit).submit();
                }
            }

        });

        $(document).on('select2:open',(e) => {

            const select_id = e.target.id;

            $(".select2-search__field[aria-controls='select2-"+select_id+"-results']").each(function (key,value){
                value.focus();
            });
        });
    },

    finalize() {

    }

}
